// --- Core ---
import React from 'react';
// --- SaniQ ---
import {TenantConfiguration} from "../models/tenant/Configuration";

const initialState: TenantConfiguration = {
  // @ts-expect-error The base configuration needs a key, according to its interface, but does actually not have one
  key: 'unused_base_key',
  isEnabled: true,
  modules: [],
  rootUrl: undefined
};

const TenantModuleContext = React.createContext(initialState);

export {
  TenantModuleContext,
  TenantModuleContext as TenantConfigurationContext,
  initialState as defaultTenantModules
};
